import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 w-full bg-navy text-white overflow-hidden" data-id="element-86">
      {/* Subtle background pattern/gradient */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.8)_0,transparent_100%)]" data-id="element-87"></div>

      <div className="max-w-sales mx-auto px-6 relative z-10 flex flex-col items-center text-center" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-block mb-6 px-4 py-1.5 rounded-full bg-white/10 border border-white/20 text-sm font-medium tracking-wide text-amber" data-id="element-89">
          EL PROTOCOLO DEL HOGAR SILENCIOSO
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-90">
          Cómo detener los ladridos, mordidas y accidentes de tu cachorro en{' '}
          <span className="text-amber italic" data-id="element-91">menos de 48 horas</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-300 mb-8 max-w-2xl" data-id="element-92">
          (sin pagar un entrenador de $500)
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-xl md:text-2xl font-medium text-white/90 mb-12 max-w-3xl leading-relaxed" data-id="element-93">
          El sistema de "Triaje Táctico" diseñado para dueños de cachorros
          agotados que necesitan recuperar su sueño y su casa este mismo fin de
          semana.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="w-full max-w-2xl mb-12 relative" data-id="element-94">
          <div className="absolute -inset-4 bg-amber/20 blur-3xl rounded-full opacity-50" data-id="element-95"></div>
          <img src="https://cdn.magicpatterns.com/uploads/rsTY7s18hzBkWPdQEwiBGh/heylloyd-image-1776625792775.png" alt="El Protocolo del Hogar Silencioso en varios dispositivos" className="w-full h-auto rounded-2xl shadow-2xl relative z-10 border border-white/10" data-id="element-96" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="w-full" data-id="element-97">
          <Button className="w-full md:w-auto text-xl py-6 px-10" data-id="element-98">
            ¡QUIERO EL PROTOCOLO AHORA!
          </Button>
          <p className="mt-4 text-sm text-white/60" data-id="element-99">
            Acceso inmediato • Pago 100% seguro
          </p>
        </motion.div>
      </div>
    </section>;
}